import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileLeftMenu = () => openPopupHelper({ popupName: popupNames.MOBILE_LEFT_MENU });
